import React from 'react';

import { Button, TrashIcon, Typography } from '@coolset/cs-ui';
import { Tooltip } from '@mui/material';
import { BlockOption } from 'modules/MainSurveyEditor/helpers/blocks';
import { BlockIcon } from 'shared/components/BlockOption/BlockIcon';

export const BlockFormHeader: React.FC<BlockFormHeaderProps> = (props) => {
  const { blockOption, allowDelete, fieldId, onDeleteBlock } = props;
  return (
    <div className="_d-flex-ali-baseline-jc-sb-sm-gap">
      <div className="_d-flex-ali-baseline-sm-gap">
        <BlockIcon blockType={blockOption.blockType} />
        <div>
          <Typography variant="h3">{blockOption.name}</Typography>
          {fieldId && <Typography>Field ID: {fieldId}</Typography>}
        </div>
      </div>
      {allowDelete && (
        <Tooltip title="Delete block">
          <Button variant="outlined" onClick={onDeleteBlock}>
            <TrashIcon />
          </Button>
        </Tooltip>
      )}
    </div>
  );
};

interface BlockFormHeaderProps {
  blockOption: BlockOption;
  allowDelete?: boolean;
  fieldId: string | null | undefined;
  onDeleteBlock: () => void;
};
